import { Spinner } from "react-bootstrap-v5";

const Load = () => {
  return (
    <div className="d-flex flex-column justify-items-center align-items-center w-100 mt-5">
      <Spinner animation="border" color="#1f1e2c" />
      <span className="text-gray-700 mt-3">...Carregando</span>
    </div>
  );
};
export { Load };
